import { useState } from 'react';
import Header from './components/Header';
import Calculator from './components/Calculator';
import Osmometer from './components/Osmometer';
import Content from './components/Content';
import Footer from './components/Footer';
import { CalculationContext } from './components/calculationContext';

import DoutoBanner from './DoutoBanner';
function App() {
  const [calculation, setCalculation] = useState(null);

  return (
    <CalculationContext.Provider value={{ calculation, setCalculation }}>
      <div className="site-shell">
        <Header />
        <main>
          <section className="hero page-width" aria-labelledby="page-title">
            <div className="hero-copy">
              <h1 id="page-title">Calculadora de osmolaridade sérica e gap osmolar</h1>
              <p className="hero-intro">
                Ferramenta precisa para estimativa da osmolaridade plasmática,
                suporte a unidades convencionais e SI, e cálculo do gap osmolar.
              </p>
              <Calculator />
            </div>
            <Osmometer />
          </section>
          <DoutoBanner />
        <Content /><p className="guide-link"><a href="/gap-osmolar-limites-interpretacao/">Gap osmolar: interpretação e limitações →</a></p>
        </main>
        <Footer />
      </div>
    </CalculationContext.Provider>
  );
}

export default App;
